import { TableCell, TableRow } from "@mui/material";
import EMICheckbox from "components/Elements/EMICheckbox";
import { useState } from "react";
import TabelRowImage from "components/Elements/TabelRowImage";
import ImageViewer from "components/Elements/ImageViewer";
import SiteAssetRegisterDropdown from "components/Elements/SiteAssetRegisterDropdown";

function ZoneRow({
	row,
	handleSelectZone,
	modelType,
	siteAssset,
	onPageChange,
	setSiteAssest,
	page,
	assestCount,
	handleServerSideSearch,
	onDropDownChange,
	isReadOnly,
	customCaptions,
	fetchSiteFromDropDown,
	fetchModelTaskZones,
	showAssetReferences,
	handleCustomSort
}) {
	const [selected, setSelected] = useState(false);
	const [openImage, setOPenImage] = useState(false);
	const [ImageToOpen, setImageToOpen] = useState(null);

	return (
		<>
			<ImageViewer
				open={openImage}
				onClose={() => {
					setOPenImage(false);
					setImageToOpen(null);
				}}
				imgSource={ImageToOpen}
			/>
			<TableRow
				data-testid={`model-task-zone-row-${row.modelVersionZoneID}`}
				style={{ height: "100%" }}
			>
				<TableCell
					data-testid="model-task-zone-row-checkbox-cell"
					style={{
						height: "100px",
					}}
				>
					<EMICheckbox
						state={row?.id ? true : false}
						changeHandler={(e) =>
							handleSelectZone(row.modelVersionZoneID, setSelected)
						}
						disabled={selected || isReadOnly}
					/>
				</TableCell>
				<TableCell data-testid="model-task-zone-row-name-cell">{row.name}</TableCell>

				{(modelType === "F" || modelType === "A") && row?.thumbnailURL ? (
					<TabelRowImage
						imageURL={row?.thumbnailURL}
						imageHeight={"100px"}
						imageWidth={"100px"}
						onClickImage={() => {
							setOPenImage(true);
							setImageToOpen(row?.imageURL);
						}}
					/>
				) : (
					<>&nbsp;</>
				)}
				{modelType === "F" ? (
					<TableCell data-testid="model-task-zone-row-asset-cell">
						<SiteAssetRegisterDropdown
							dataSource={siteAssset}
							selectedValue={row.siteAssetRegisterID ? {
								id: row.siteAssetRegisterID,
								assetNumber: row.siteAssetRegisterAssetNumber,
								reference: row.siteAssetRegisterReference,
							} : null}
							handleCustomSort={handleCustomSort}
							onChange={(list) => onDropDownChange(row.id, list)}
							count={assestCount}
							onPageChange={onPageChange}
							page={page}
							handleServerSideSearch={handleServerSideSearch}
							disabled={selected || row.id === null}
							isReadOnly={isReadOnly}
							customCaptions={customCaptions}
							fetchData={() =>
								fetchSiteFromDropDown(
									row.defaultSiteAssetFilter !== null
										? row.defaultSiteAssetFilter
										: ""
								)
							}
							preloadedSearch={row.defaultSiteAssetFilter}
							showReference={showAssetReferences}
							cacheDropDownData={false}
						/>
					</TableCell>
				) : null}
			</TableRow>
		</>
	);
}

export default ZoneRow;
